var map = {
	"./cs.translation.ts": "../../libs/i18n/src/lib/translations/cs.translation.ts",
	"./de.translation.ts": "../../libs/i18n/src/lib/translations/de.translation.ts",
	"./es.translation.ts": "../../libs/i18n/src/lib/translations/es.translation.ts",
	"./fr.translation.ts": "../../libs/i18n/src/lib/translations/fr.translation.ts",
	"./it.translation.ts": "../../libs/i18n/src/lib/translations/it.translation.ts",
	"./sv.translation.ts": "../../libs/i18n/src/lib/translations/sv.translation.ts",
	"./zh.translation.ts": "../../libs/i18n/src/lib/translations/zh.translation.ts"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "../../libs/i18n/src/lib/translations sync recursive ^\\.\\/.*\\.translation\\.ts$";